import { useEffect, useState } from "react";
import { Layout } from "components";
import { useParams } from "react-router-dom";
import { Divider, ProgressSteps } from "theme";

import { Box, CircularProgress, Grid2 } from "@mui/material";

import { useBookingById } from "../../api/hooks/useBookingById/useBookingById.ts";
import BookingInfoForm from "../../components/Forms/BookingInfoForm/BookingInfoForm.tsx";
import EquipmentForm from "../../components/Forms/EquipmentForm/EquipmentForm.tsx";
import SummaryForm from "../../components/Forms/SummaryForm/SummaryForm.tsx";
import { useBooking } from "../../utils/context/Booking/BookingContext.tsx";
import {
  mapBookingToEquipmentForm,
  mapBookingToInfoForm,
} from "../../utils/context/Booking/mapBookingResponse.ts";

const Booking = () => {
  const { id } = useParams();
  const { setBooking, setEquipment, booking } = useBooking();
  const [step, setStep] = useState(1);
  const { data, isFetching } = useBookingById();

  useEffect(() => {
    if (data) {
      setBooking(mapBookingToInfoForm(data));
    }
    setEquipment(mapBookingToEquipmentForm(data));
  }, [data, setBooking, setEquipment]);

  if (isFetching) {
    return <Layout>
      <Grid2 container justifyContent="center">
        <CircularProgress color="secondary" />
      </Grid2>
    </Layout>;
  }

  return (
    <Layout>
      <Grid2 mb={2.5} container justifyContent="center">
        <Box width="100%" maxWidth="580px">
          <ProgressSteps activeStep={step} steps={["Загальна інформація", "Додаткове обладдння", "Оплата"]} />
        </Box>
      </Grid2>
      <Divider />

      {
        id === "new" ? <>
          {
            step === 1 && <BookingInfoForm setStep={setStep} />
          }
          {
            step === 2 && <EquipmentForm setStep={setStep} />
          }
          {
            step === 3 && <SummaryForm setStep={setStep} />
          }
        </> : <>
          {
            booking && <>
              {
                step === 1 && <BookingInfoForm setStep={setStep} />
              }
              {
                step === 2 && <EquipmentForm setStep={setStep} />
              }
              {
                step === 3 && <SummaryForm setStep={setStep} />
              }
            </>
          }
        </>
      }

      <Divider />

    </Layout>
  );
};

export default Booking;
